export default __webpack_public_path__ + "images/28346e1d3a25d7e828cca78ea69f2f91-democratic_party.jpg";